import { openDB, deleteDB } from 'idb';
import { updateUserState, setUserStateLoaded } from './storeValtio';

const DATABASE_NAME = 'ITIW';
const DATABASE_VERSION = 5;

export var db;
export function setDb(dbx) {
  db = dbx;
}

export async function getAll(store) {
  return db.getAll(store)
}

export async function getAllData(store) {
  //console.log('getAllData', store, db);
  let response = await db.getAll(store)
  let result = await response;
  //if (result.length === 0) console.log("getAllData() no data in store:", store);
  return result;
}

export async function deleteDatabase() {
  console.log('deleteDatabase', db);
  try {
    db.close();
    await deleteDB(DATABASE_NAME, {blocked(currentVersion, e) {
    console.log('blocked', currentVersion, e);
    return false;
    }});
  } catch(error) {
    console.log('deleteDB Error', error);
    return false;
  }
  return true;
}

export async function openDatabase() {
  const result = await openDB(DATABASE_NAME, DATABASE_VERSION, {
    upgrade(db, oldVersion, newVersion, transaction) {
      console.log('Upgrading DB:', oldVersion, newVersion);
      if (oldVersion < 3) // starting from scratch
        upgradeDb3();

      if (oldVersion < 4)
        upgradeDb4();

      if (oldVersion < 5) {
        upgradeDb5();
      }

      function upgradeDb5() {
        console.log("DB Ugrade 5");
        db.createObjectStore("drugData");
      }

      function upgradeDb4() {
        console.log("DB Ugrade 4");
        const os1 = db.createObjectStore("prescriptions", {
          keyPath: "prescriptionId"
        } );
        os1.createIndex( "userId", "userId", {
          unique: false
        });
        os1.createIndex( "medicationId", "medicationId", {
          unique: false
        });
      }

      function upgradeDb3() {
        console.log("DB Ugrade 3");
        const os1 = db.createObjectStore("users", {
          keyPath: "userId"
        } );
        os1.createIndex( "displayName", "displayName", {
          unique: true
        });

        const os2 = db.createObjectStore("medications", {
          keyPath: "medicationId"
        });
        os2.createIndex( "userId", "userId", {
          unique: false
        });

        const os3 = db.createObjectStore("history", {
          keyPath: "historyId"
        });
        os3.createIndex( "medicationId", "medicationId", {
          unique: false
        });
        os3.createIndex( "userId", "userId", {
          unique: false
        });

        const os4 = db.createObjectStore("conditions", {
          keyPath: "conditionId"
        });
        os4.createIndex( "userId", "userId", {
          unique: false
        });

        const os5 = db.createObjectStore("supplements", {
          keyPath: "supplementId"
        });
        os5.createIndex( "userId", "userId", {
          unique: false
        });
        os5.createIndex( "labelId", "labelId", {
          unique: false
        });

        const os6 = db.createObjectStore("ingredients", {
          keyPath: "ingredientId"
        });
        os6.createIndex( "DsldId", "DsldId", {
          unique: true
        });
        os6.createIndex( "medicationId", "medicationId", {
          unique: false
        });
        os6.createIndex( "userId", "userId", {
          unique: false
        });

        const os7 = db.createObjectStore("transactions", {
          keyPath: "transactionId"
        } );
      }
    }
  })
  return result
};


export async function getUser(userId) {
  setUserStateLoaded(false);
  if (!userId) return null;
  //console.log("getUser", userId);
  return await db.get('users', userId)
    .then((result) => {
      //console.log('getUser result: ', result);
      var user = null;
      if (result.length === 0) {
        //console.log("no user in db");
        } else {
          //console.log("user in db", result);
          user = result;
          const dbUser = {
            loaded: true,
            authenticated: true,
            currentUser: user,
            currentUserId: user.userId
          }
          updateUserState(dbUser);
        }

      return user;
      })
    .catch((err) => {
    console.log('getUser error: ', err);
  });
}

export async function insertValuesArray(store, data) {
  var promises = []
  data.forEach(item => {
    var p = insertValues(store, item);
    promises.push(p);
  }) 
  await Promise.all(promises);
}

export async function insertValues(store, data) {
  //console.log('insertValues', store, data);
  try {
    let response = await db.add(store, data);
    let result = await response;
    //console.log('insertValues result', result);
    return result;
  } catch (err) {
    console.log('insertValues error', err);
    return null;
  }
}

export async function insertValuesWithKey(store, data, key) {
  //console.log('insertValues', store, data, key);
  let response = await db.add(store, data, key)
  let result = await response;
  //console.log('insertValuesWithKey result', result);
  return result;
}

export async function getData(store, key) {
  let response = await db.get(store, key)
  let result = await response;
  //console.log('getData result: ', result);
  if (!result) {
    console.log("getData - no data in store:", store, key);
    return null;
  }
  return result;
}

export async function getAllDataPromise(store) {
  var tx = db.transaction(store, 'readonly');
  var st = tx.objectStore(store);
  return st.getAll();
}

export async function getSelectedData(store, index, key) {
  //console.log('getSelectedData', store, index, key);
  let response =  await db.getAllFromIndex(store, index, key)
  let result = await response;
  //console.log('getSelectedData result: ', store, result);
  //if (result.length === 0) console.log("getSelectedData() no data in store:", store, index, key);
  return result;
}

export async function getIndexedData(store, index, key) {
  console.log('getIndexedData', store, index, key);
  let response = await db.getFromIndex(store, index, key)
  let result = await response;
  //console.log('getIndexedData result: ', result);
  if (!result) {
    console.log("getIndexedData() no data in store:", store, index, key);
    return null;
  }
}

export async function getDataRange(store, indexes, range) {
  console.log('getDataRange', store, indexes, range);
  return await db.objectStore(indexes).get(range)
    .then((result) => {
      //console.log('getDataRange result: ', result);
      if (!result) {
        console.log("getDataRange() no data in store:", store);
        return null;
      }
      return result;
      })
    .catch((err) => {
      console.log('getDataRange error: ', err);
      return null;
    });
}

export async function updateData(store, data) {
  //console.log('updateData', store, data);
  let response = db.put(store, data)
  let result = await response;
  //console.log("UpdateData response", result);
  return result;
}

export async function deleteAllData(store) {
  let response = await db.clear(store);
  let result = await response;
  console.log("All Data Deleted", store, result);
}

export async function deleteData(store, id) {
  await db.delete(store, id);
  //console.log("Data Deleted", store, id);
}

export async function deleteIndexedData(store, key) {
  try {
    var tx = db.transaction(store, 'readwrite');
    var sx = tx.objectStore(store);
    let deleteRequest = await sx.delete(key);
    //console.log('record deleted:', store, key);
  } catch(err) {
    console.log('deleteIndexedData error:', store, key);
    console.log(err);
  }
}

export async function deleteIndexedDataByIndex(store, index, key) {
  try {
    var tx = db.transaction(store, 'readwrite');
    var sx = tx.objectStore(store);
    let deleteRequest = sx.delete(key);

    deleteRequest.onsuccess = function(event) {
      console.log('deleted cursor:', store, key);
    };

    var ix = sx.index(index);
    var ck = ix.openCursor(key);
    ck.then(async cursor => {
      while (cursor) {
          //console.log('deleting cursor:', cursor);
          cursor.delete();
          cursor = await cursor.continue();
      }
    })
    .catch(err => {
      console.log('Failed to delete cursor:', store, index, key);
      console.log(err);
      });
  } catch(err) {
    console.log('deleteIndexedData error:', store, index, key);
    console.log(err);
  }
}

export async function replaceDrugData(
  dataKey,
  data,
  metadataKey,
  metadata
) {
  if (!db) {
    throw new Error("IndexedDB has not been opened");
  }

  const tx = db.transaction("drugData", "readwrite");
  const store = tx.objectStore("drugData");

  await store.put(data, dataKey);
  await store.put(metadata, metadataKey);
  await tx.done;
}

export async function deleteReferenceData(key) {
  if (!db) {
    throw new Error("IndexedDB has not been opened");
  }

  await db.delete("drugData", key);
}
